import { render, staticRenderFns } from "./SMSAuthPhonNumberForm.vue?vue&type=template&id=1353814e"
import script from "./SMSAuthPhonNumberForm.vue?vue&type=script&lang=js"
export * from "./SMSAuthPhonNumberForm.vue?vue&type=script&lang=js"
import style0 from "./SMSAuthPhonNumberForm.vue?vue&type=style&index=0&id=1353814e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports